import { useInternational } from '@/common/locale';
import type { LanguageItem } from './myInfoPopup.types';

export interface Props {
  languageList: LanguageItem[];
  selectedLanguage: string;
}

export interface Emit {
  (e: 'click-language-item', language: LanguageItem): void;
}

export const setup = (emit: Emit) => {
  const { t } = useInternational();

  const onClickLanguageItem = (language: LanguageItem) => {
    emit('click-language-item', language);
  };

  return {
    t,

    onClickLanguageItem,
  };
};
